(function () {
  const formatEUR = (cents) => {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents);
    }
    const v = (cents / 100).toFixed(2).replace(".", ",");
    return v + " €";
  };

  function render(cart) {
    document.querySelectorAll(".free-ship").forEach((w) => {
      const thresholdCents = parseInt(w.dataset.thresholdCents || "7000", 10);
      const totalCents = cart.total_price || 0;

      const textEl = w.querySelector("[data-free-ship-text]");
      const fillEl = w.querySelector("[data-free-ship-fill]");

      const progress = Math.max(0, Math.min(1, totalCents / thresholdCents));
      if (fillEl) fillEl.style.width = Math.round(progress * 100) + "%";

      if (!textEl) return;

      if (totalCents >= thresholdCents) {
        textEl.textContent = "🎉 Kostenloser Versand freigeschaltet!";
      } else {
        const remaining = thresholdCents - totalCents;
        textEl.textContent = `Noch ${formatEUR(remaining)} bis kostenloser Versand`;
      }
    });
  }

  async function update() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return;
      const cart = await res.json();
      render(cart);
    } catch (e) {}
  }

  // initial
  document.addEventListener("DOMContentLoaded", update);

  // bei Dawn/Ajax Änderungen
  document.addEventListener("cart:updated", update);
  document.addEventListener("cart:refresh", update);

  // extra robust: wenn Drawer-Inhalt sich ändert
  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    const mo = new MutationObserver(() => update());
    mo.observe(drawer, { subtree: true, childList: true });
  }
})();
